import ImageWMS from "ol/source/ImageWMS";
import ImageLayer from "ol/layer/Image";

import { get } from "ol/proj";
import { DateTime } from "luxon";
import { wmsSpeedStyle } from "./style/util/colorScale";
export const DIRECTIONAL_OPACITY = 0.4;
export const SPEED_OPACITY = 0.99;
export const SPEED_BREAKPOINTS = [0, 15, 30, 50, 70, 90, 120, 130];

const imageURLMap = {};

function getParams(
  direction,
  startDateISO,
  endDateISO,
  dataSource,
  displayMode,
) {
  if (displayMode === "speed") {
    return {
      LAYERS: "speed",
      SPEED_STYLE: wmsSpeedStyle(SPEED_BREAKPOINTS),
      STYLES: null,
      VERSION: "1.1.1",
      TIME: `${startDateISO}/${endDateISO}`,
      DATE_RANGE: null,
      ONLY_ALLOW_DIRECTIONS: "" + direction,
      DATA_SOURCE: dataSource,
    };
  }
  const startDate = DateTime.fromISO(startDateISO).toFormat("yyooo");
  const endDate = DateTime.fromISO(endDateISO).toFormat("yyooo");
  return {
    LAYERS: "averagedtrf",
    VERSION: "1.1.1",
    DATE_RANGE: `${startDate}-${endDate}`,
    TIME: null,
    SPEED_STYLE: null,
    STYLES: null,
    ONLY_ALLOW_DIRECTIONS: "" + direction,
    DATA_SOURCE: dataSource,
  };
}

function getImageWMS(direction, startDateISO, endDateISO, idToken, dataSource) {
  return new ImageWMS({
    url: process.env.HEATMAP_URL + "?",
    params: getParams(
      direction,
      startDateISO,
      endDateISO,
      dataSource,
      "density",
    ),
    ratio: 1,
    projection: get("EPSG:900913"),
    imageLoadFunction: function (image, url) {
      const headers = { Authorization: "Bearer " + idToken };
      fetch(url, { headers }).then((response) =>
        response.blob().then((imageData) => {
          let objectUrl = window.URL.createObjectURL(imageData);
          image.getImage().src = objectUrl;

          // cleanup
          if (imageURLMap[direction]) {
            window.URL.revokeObjectURL(imageURLMap[direction]);
          }
          imageURLMap[direction] = objectUrl;
        }),
      );
      image.getImage().onchange = function (event) {
        console.log("change on heatmap layer event: " + event);
      };
    },
  });
}

function updateLayer(
  layer,
  direction,
  dateInputControl,
  azureLoginControl,
  dataSourceControl,
  directionalHeatmapControl,
) {
  layer
    .getSource()
    .updateParams(
      getParams(
        direction,
        dateInputControl.get("startDate"),
        dateInputControl.get("endDate"),
        dataSourceControl.get("dataSource"),
        directionalHeatmapControl.get("displayMode"),
      ),
    );
  layer.getSource().refresh();
}

export function getDirectionalLayers(
  dateInputControl,
  azureLoginControl,
  dataSourceControl,
  directionalHeatmapControl,
) {
  var layers = new Map();

  for (var direction = 1; direction < 13; direction++) {
    const layer = new ImageLayer({
      opacity: DIRECTIONAL_OPACITY,
      minZoom: 17,
      source: getImageWMS(
        direction,
        dateInputControl.get("startDate"),
        dateInputControl.get("endDate"),
        azureLoginControl.get("idToken"),
        dataSourceControl.get("dataSource"),
      ),
    });

    layers.set(direction + "", layer);

    const boundUpdate = updateLayer.bind(
      this,
      layer,
      direction,
      dateInputControl,
      azureLoginControl,
      dataSourceControl,
      directionalHeatmapControl,
    );

    dateInputControl.on("propertychange", boundUpdate);
    azureLoginControl.on("propertychange", boundUpdate);
    dataSourceControl.on("propertychange", boundUpdate);
    directionalHeatmapControl.on("propertychange", boundUpdate);
  }
  return layers;
}
